<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle"><i class="pe-7s-box2 text-white"></i></div>
        <div>
          Products &amp; Workflow
          <div class="page-title-subheading">Product Master and Step Master.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="mb-3 card">
        <div class="card-header d-flex justify-content-between align-items-center">
          Products
          <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#productModal" (click)="openAddModal()">
            <i class="fa fa-plus mr-1"></i> Add Product
          </button>
        </div>
        <div class="card-body">
          <div *ngIf="loading" class="text-center py-5">
            <span class="spinner-border text-primary"></span>
          </div>
          <vio-table-v2 *ngIf="!loading" [tableData]="tableData" [tableConfig]="tableConfig"></vio-table-v2>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Product modal -->
  <div class="modal fade" id="productModal" tabindex="-1" aria-hidden="true" appAppendToBody>
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ operation === 'Add' ? 'Add Product' : 'Edit Product' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <app-bilingual-name-field
            label="Name"
            placeholder="Name"
            [(name)]="productForm.name"
            [(nameMr)]="productForm.nameMr"
          ></app-bilingual-name-field>
          <div class="form-group">
            <label class="required">Code</label>
            <input class="form-control" placeholder="Code" [(ngModel)]="productForm.code" [disabled]="operation === 'Edit'" />
            <small class="text-muted" *ngIf="operation === 'Edit'">Code can't be changed after creation.</small>
          </div>
          <div class="form-group">
            <label>Description</label>
            <input class="form-control" placeholder="Description" [(ngModel)]="productForm.description" />
          </div>
          <p class="text-muted small mb-0" *ngIf="operation === 'Add'">
            <i class="fa fa-info-circle mr-1"></i>
            Monthly targets are set separately — use the "Monthly Target" button on the product list once it's created.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #productModalCloseBtn>Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveProduct()">
            <i class="fa" [class.fa-plus]="operation === 'Add'" [class.fa-check]="operation === 'Edit'"></i>
            {{ operation === 'Add' ? 'Add Product' : 'Save Changes' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Per-product modals: Steps -->
  <ng-container *ngFor="let product of products; trackBy: trackByProductId">
    <!-- Steps modal -->
    <div class="modal fade" id="stepsModal-{{ product._id }}" tabindex="-1" aria-hidden="true" appAppendToBody>
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Steps — {{ product.name }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Steps</h6>
              <small class="text-muted"><i class="fa fa-info-circle mr-1"></i>Click the <i class="fa fa-plus text-primary mx-1"></i> next to a step to add a new one after it.</small>
            </div>
            <div class="table-responsive">
              <table class="align-middle mb-0 table table-borderless table-striped">
                <thead>
                  <tr>
                    <th></th>
                    <th>#</th>
                    <th>Name</th>
                    <th>Short Name</th>
                    <th>Result Part Name</th>
                    <th>Description</th>
                    <th>Machine Type</th>
                    <th>Machine(s)</th>
                    <th class="text-center">Order</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let step of sortedSteps(product)">
                    <td class="align-top">
                      <button
                        class="btn btn-sm btn-outline-primary"
                        title="Insert a new step right after this one"
                        (click)="openAddStepModal(product, step)"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </td>
                    <td>{{ step.sequence }}</td>
                    <td>{{ step.name }}<ng-container *ngIf="step.nameMr"> ({{ step.nameMr }})</ng-container></td>
                    <td>
                      <ng-container *ngIf="step.shortName; else noShortName"
                        >{{ step.shortName }}<ng-container *ngIf="step.shortNameMr"> ({{ step.shortNameMr }})</ng-container></ng-container
                      >
                      <ng-template #noShortName>—</ng-template>
                    </td>
                    <td>
                      <ng-container *ngIf="step.outputName; else noOutputName"
                        >{{ step.outputName }}<ng-container *ngIf="step.outputNameMr"> ({{ step.outputNameMr }})</ng-container></ng-container
                      >
                      <ng-template #noOutputName>—</ng-template>
                    </td>
                    <td>{{ step.description || '—' }}</td>
                    <td>{{ machineTypeNameFor(step) }}</td>
                    <td>{{ machineNamesFor(step) }}</td>
                    <td class="text-center align-top">
                      <button class="btn btn-sm btn-outline-primary mr-1 mb-1" title="Move up" (click)="moveStep(product, step, -1)">&uarr;</button>
                      <button class="btn btn-sm btn-outline-primary" title="Move down" (click)="moveStep(product, step, 1)">&darr;</button>
                    </td>
                    <td class="text-right align-top">
                      <button class="btn btn-sm btn-outline-primary mr-1 mb-1" title="Edit step" (click)="openEditStepModal(product, step)">
                        <i class="fa fa-pencil-alt mr-1"></i> Edit
                      </button>
                      <button class="btn btn-sm btn-outline-danger" title="Delete step" (click)="deleteStep(product, step)">
                        <i class="fa fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="product.steps.length === 0">
                    <td colspan="10" class="text-center text-muted py-3">
                      No steps yet —
                      <button class="btn btn-sm btn-outline-primary ml-1" (click)="openAddStepModal(product)">
                        <i class="fa fa-plus mr-1"></i> Add the first step
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Step modal — swaps in for the Steps modal (not stacked on top of it) while open, and
    swaps back to Steps on close, so only one Bootstrap modal/backdrop is ever live at once. -->
    <div class="modal fade" id="addStepModal-{{ product._id }}" tabindex="-1" aria-hidden="true" appAppendToBody>
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <h5 class="modal-title mb-0">{{ stepOperation === 'Add' ? 'Add Step' : 'Edit Step' }} — {{ product.name }}</h5>
              <small class="text-muted" *ngIf="stepOperation === 'Add' && insertAfterStepId">Inserted right after the step you picked.</small>
            </div>
            <button type="button" class="btn-close" (click)="closeAddStepModal(product)" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <app-bilingual-name-field
              label="Step Name"
              placeholder="Name"
              [(name)]="newStep.name"
              [(nameMr)]="newStep.nameMr"
            ></app-bilingual-name-field>

            <app-bilingual-name-field
              label="Short Name"
              placeholder="Short Name"
              [(name)]="newStep.shortName"
              [(nameMr)]="newStep.shortNameMr"
            ></app-bilingual-name-field>

            <app-bilingual-name-field
              label="Result Part Name"
              placeholder="e.g. Cut Blank"
              [(name)]="newStep.outputName"
              [(nameMr)]="newStep.outputNameMr"
            ></app-bilingual-name-field>

            <div class="form-group">
              <label>Description</label>
              <textarea class="form-control" rows="2" placeholder="Optional details about this step" [(ngModel)]="newStep.description"></textarea>
            </div>

            <div class="form-group">
              <label>Machine Type <span class="text-muted fw-normal">(optional — leave blank for a manual/process step)</span></label>
              <select class="form-select" [(ngModel)]="newStep.machineTypeId" (ngModelChange)="onNewStepMachineTypeChange()">
                <option value="">No Machine Type (process step)</option>
                <option *ngFor="let machineType of machineTypes" [value]="machineType._id">{{ machineType.name }}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="newStep.machineTypeId">
              <label>Machine(s)</label>
              <div class="dropdown machine-multiselect">
                <button
                  class="form-select machine-multiselect-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  aria-expanded="false"
                >
                  <span *ngIf="newStep.machineIds.length">{{ machineNamesForIds(newStep.machineIds) }}</span>
                  <span class="text-muted" *ngIf="!newStep.machineIds.length">Select machine(s)</span>
                </button>
                <div class="dropdown-menu machine-multiselect-menu">
                  <div class="form-check" *ngFor="let machine of machinesForType(newStep.machineTypeId)">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'newStepMachine-' + product._id + '-' + machine._id"
                      [checked]="newStep.machineIds.includes(machine._id)"
                      (change)="toggleNewStepMachine(machine._id)"
                    />
                    <label class="form-check-label" [for]="'newStepMachine-' + product._id + '-' + machine._id">{{ machine.name }}</label>
                  </div>
                  <div class="text-muted small px-3 py-2" *ngIf="machinesForType(newStep.machineTypeId).length === 0">No machines available.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeAddStepModal(product)">Cancel</button>
            <button type="button" class="btn btn-primary" [disabled]="!newStep.name" (click)="saveStep(product)">
              <i class="fa" [class.fa-plus]="stepOperation === 'Add'" [class.fa-check]="stepOperation === 'Edit'"></i>
              {{ stepOperation === 'Add' ? 'Add Step' : 'Save Changes' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Monthly Target modal — edits the current calendar year's 12 months at once. -->
    <div class="modal fade" id="targetModal-{{ product._id }}" tabindex="-1" aria-hidden="true" appAppendToBody>
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title d-flex align-items-center">
              <i class="header-icon fa fa-bullseye icon-gradient bg-arielle-smile mr-2"></i>
              Monthly Target — {{ product.name }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" *ngIf="targetModalProduct === product">
            <p class="text-muted small mb-3">
              Set how many units this product should complete each month of {{ targetMonths[0].slice(0, 4) }}. The dashboard tracks
              month-to-date progress against whichever month is current.
            </p>
            <div class="row target-month-grid">
              <div class="col-md-4 target-month-field" *ngFor="let month of targetMonths; let i = index">
                <label [class.current]="isCurrentMonth(month)">
                  {{ targetMonthLabels[i] }}
                  <span class="badge badge-pill badge-primary target-current-badge" *ngIf="isCurrentMonth(month)">Current</span>
                </label>
                <input class="form-control" type="number" min="0" [(ngModel)]="targetForm[month]" />
              </div>
            </div>
          </div>
          <div class="modal-footer target-modal-footer">
            <div class="target-year-total" *ngIf="targetModalProduct === product">
              <span class="text-muted">Year total:</span>
              <strong>{{ targetYearTotal }}</strong>
            </div>
            <div class="target-modal-actions">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button
                type="button"
                class="btn btn-primary"
                [disabled]="!targetFormDirty || savingTargets"
                (click)="saveMonthlyTargets(product)"
              >
                <span class="spinner-border spinner-border-sm mr-1" *ngIf="savingTargets"></span>
                <i class="fa fa-check mr-1" *ngIf="!savingTargets"></i>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Workflow Configuration modal -->
    <div class="modal fade" id="workflowModal-{{ product._id }}" tabindex="-1" aria-hidden="true" appAppendToBody>
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Workflow Configuration — {{ product.name }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="workflow-mode-group">
              <label class="workflow-mode-label">Validation Mode</label>
              <p class="workflow-mode-sublabel">Applies to every step in this product.</p>
              <div class="workflow-mode-cards">
                <label
                  class="workflow-mode-card"
                  *ngFor="let mode of workflowModeOptions"
                  [class.active]="workflowMode === mode.value"
                  [for]="'workflowMode-' + product._id + '-' + mode.value"
                >
                  <input
                    type="radio"
                    class="workflow-mode-card-radio"
                    name="workflowMode-{{ product._id }}"
                    [id]="'workflowMode-' + product._id + '-' + mode.value"
                    [value]="mode.value"
                    [(ngModel)]="workflowMode"
                  />
                  <span class="workflow-mode-card-icon"><i class="fa" [ngClass]="mode.icon"></i></span>
                  <span class="workflow-mode-card-title">{{ mode.label }}</span>
                  <span class="workflow-mode-card-desc">{{ mode.description }}</span>
                </label>
              </div>
            </div>

            <div class="workflow-deps" *ngIf="workflowMode === 'dependencyBased'">
              <label class="workflow-mode-label">Step Dependencies</label>
              <p class="workflow-mode-sublabel">Pick which steps each step must wait on.</p>
              <div class="workflow-step-card" *ngFor="let step of sortedSteps(product)">
                <strong>{{ step.name }}</strong>
                <span class="text-muted small d-block mb-2">must wait on:</span>
                <div class="workflow-dep-chips">
                  <ng-container *ngFor="let other of sortedSteps(product)">
                    <ng-container *ngIf="other._id !== step._id">
                      <input
                        type="checkbox"
                        class="btn-check"
                        [id]="'dep' + step._id + other._id"
                        [checked]="step.dependsOn.includes(other._id)"
                        (change)="toggleDependsOn(step, other._id)"
                      />
                      <label class="btn btn-sm btn-outline-secondary workflow-dep-chip" [for]="'dep' + step._id + other._id">
                        {{ other.name }}
                      </label>
                    </ng-container>
                  </ng-container>
                  <span class="text-muted small" *ngIf="sortedSteps(product).length <= 1">No other steps to depend on.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="saveWorkflow(product)">Save Workflow</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
